import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient , HttpClientModule , HTTP_INTERCEPTORS ,HttpClientXsrfModule} from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class CleintService {
  constructor(public http: HttpClient,public handler: HttpBackend) { }

  getTimeByDayId(date:any) {
    return this.http
      .get(`${environment.bookingBaseUrl}appointments/getAvailableTimes/${date}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  getPrice()
  {
      return this.http
          .get(`${environment.bookingBaseUrl}getPrice`)
          .pipe(
              map((data) => data),
              catchError((error) => {
                  throw error;
              })
          );
  }

  getsocial_media() {
    return this.http
      .get(`${environment.bookingBaseUrl}social_media`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }
  

  NewAppointments(params: any) {
    return this.http
      .post(`${environment.bookingBaseUrl}appointments` ,  params)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

  getAvailableCourts(date , time) {
    return this.http
      .get(`${environment.bookingBaseUrl}appointments/getAvailableCourts/${date}/${time}`)
      .pipe(
        map((data) => data),
        catchError((error) => {
          throw error;
        })
      );
  }

}
